(function (root, factory) {
  if (typeof define === 'function' && define.amd) {
    define([], function(){ return factory(root); });
  } else if (typeof module === 'object' && module.exports) {
    module.exports = factory(globalThis || (typeof self !== 'undefined' ? self : this));
  } else {
    root.SwishNetballLines = factory(root);
  }
}(typeof self !== 'undefined' ? self : this, function (GLOBAL) {
  'use strict';

  function resolveOfficial(rulesetId) {
    const cfg = GLOBAL && GLOBAL.SwishCBConfig;
    if (cfg && typeof cfg.resolveOfficialCourtGeometry === 'function') {
      try { return cfg.resolveOfficialCourtGeometry(rulesetId, { noSeries: true }); } catch (_) {}
    }
    return null;
  }

  const OFFICIAL = resolveOfficial('NETBALL');
  const OFFICIAL_RAW = (OFFICIAL && OFFICIAL.official) || {};
  const OFFICIAL_FEATURE = OFFICIAL && OFFICIAL.features && OFFICIAL.features.netball;
  const DEFAULTS = {
    LENGTH: Number(OFFICIAL && OFFICIAL.officialLengthM) || 30.5,
    WIDTH: Number(OFFICIAL && OFFICIAL.officialWidthM) || 15.25,
    LINE: Number(OFFICIAL && OFFICIAL.lineWidthM) || 0.05,
    GOAL_CIRCLE_R: Number(OFFICIAL_FEATURE && OFFICIAL_FEATURE.goalCircleRadiusM) || 4.9,
    CENTER_R: Number(OFFICIAL_FEATURE && OFFICIAL_FEATURE.centerCircleRadiusM) || 0.45,
    POST_R: Number(OFFICIAL_FEATURE && OFFICIAL_FEATURE.goalPostVisibleRadiusM) || Number(OFFICIAL_RAW.goalPostMarkerR) || 0.1
  };
  const SKIP_COLOR = '__SKIP__';

  function normHex(x) {
    if (!x) return '#FFFFFF';
    x = String(x).trim();
    if (x[0] !== '#') x = '#' + x;
    return x.toUpperCase();
  }
  function hasKeys(obj) {
    if (!obj) return false;
    for (const _ in obj) return true;
    return false;
  }
  function pos(value, fallback) {
    const n = Number(value);
    return Number.isFinite(n) && n > 0 ? n : fallback;
  }
  function clamp(value, min, max) {
    return Math.max(min, Math.min(max, value));
  }
  function makePart(id, order, role, fallback, side, draw) {
    return { id, order, role, fallback, side, draw };
  }

  function computeDims(cw, ch, opts) {
    const L = pos(opts && opts.playableLengthM, DEFAULTS.LENGTH);
    const W = pos(opts && opts.playableWidthM, DEFAULTS.WIDTH);
    const line = pos(opts && opts.lineWidthM, DEFAULTS.LINE);
    const radiusRaw = pos(
      opts && (opts.netballGoalCircleRadiusM || opts.goalCircleRadiusM || opts.goalPostRadiusM),
      DEFAULTS.GOAL_CIRCLE_R
    );
    const radius = clamp(radiusRaw, line, Math.max(line, Math.min(L * 0.5, W * 0.5)));
    const scaleX = cw / Math.max(0.001, L);
    const scaleY = ch / Math.max(0.001, W);
    return {
      L,
      W,
      line,
      radius,
      centerR: clamp(pos(opts && opts.centerCircleRadiusM, DEFAULTS.CENTER_R), line, Math.max(line, Math.min(L, W) * 0.5)),
      postR: pos(opts && opts.goalPostMarkerRadiusM, DEFAULTS.POST_R),
      scaleX,
      scaleY,
      scaleAvg: (scaleX + scaleY) * 0.5,
      cw,
      ch
    };
  }

  function mx(d, x) { return x * d.scaleX; }
  function my(d, y) { return y * d.scaleY; }

  function fillRect(ctx, d, color, x, y, w, h) {
    ctx.fillStyle = (GLOBAL.SwishCBHardwood && typeof GLOBAL.SwishCBHardwood.getFillStyle === 'function')
      ? GLOBAL.SwishCBHardwood.getFillStyle(ctx, color, { hardwood: d.hardwood, pixelsPerMeter: d.scaleAvg })
      : color;
    ctx.fillRect(mx(d, x), my(d, y), w * d.scaleX, h * d.scaleY);
  }

  function fillPerimeterStrip(ctx, d, color, edge) {
    const lineW = Math.min(d.cw, Math.max(1, d.line * d.scaleX));
    const lineH = Math.min(d.ch, Math.max(1, d.line * d.scaleY));
    ctx.save();
    ctx.fillStyle = color;
    if (edge === 'top') {
      ctx.fillRect(0, 0, d.cw, lineH);
    } else if (edge === 'bottom') {
      ctx.fillRect(0, Math.max(0, d.ch - lineH), d.cw, lineH);
    } else if (edge === 'left') {
      ctx.fillRect(0, 0, lineW, d.ch);
    } else if (edge === 'right') {
      ctx.fillRect(Math.max(0, d.cw - lineW), 0, lineW, d.ch);
    }
    ctx.restore();
  }

  function strokeLine(ctx, d, color, x1, y1, x2, y2, widthM) {
    ctx.save();
    ctx.strokeStyle = color;
    ctx.lineWidth = Math.max(1, (widthM || d.line) * d.scaleAvg);
    ctx.lineCap = 'butt';
    ctx.lineJoin = 'round';
    ctx.beginPath();
    ctx.moveTo(mx(d, x1), my(d, y1));
    ctx.lineTo(mx(d, x2), my(d, y2));
    ctx.stroke();
    ctx.restore();
  }

  function strokeCircle(ctx, d, color, x, y, r, widthM) {
    if (!(r > 0)) return;
    ctx.save();
    ctx.strokeStyle = color;
    ctx.lineWidth = Math.max(1, (widthM || d.line) * d.scaleAvg);
    ctx.beginPath();
    ctx.ellipse(mx(d, x), my(d, y), r * d.scaleX, r * d.scaleY, 0, 0, Math.PI * 2);
    ctx.stroke();
    ctx.restore();
  }

  function goalCirclePath(ctx, d, side) {
    const c = d.W * 0.5;
    const r = d.radius;
    if (side === 'left') {
      ctx.moveTo(mx(d, 0), my(d, c - r));
      ctx.ellipse(mx(d, 0), my(d, c), r * d.scaleX, r * d.scaleY, 0, -Math.PI / 2, Math.PI / 2, false);
    } else {
      ctx.moveTo(mx(d, d.L), my(d, c + r));
      ctx.ellipse(mx(d, d.L), my(d, c), r * d.scaleX, r * d.scaleY, 0, Math.PI / 2, Math.PI * 1.5, false);
    }
  }

  function fillGoalCircle(ctx, d, color, side) {
    ctx.save();
    ctx.fillStyle = (GLOBAL.SwishCBHardwood && typeof GLOBAL.SwishCBHardwood.getFillStyle === 'function')
      ? GLOBAL.SwishCBHardwood.getFillStyle(ctx, color, { hardwood: d.hardwood, pixelsPerMeter: d.scaleAvg })
      : color;
    ctx.beginPath();
    goalCirclePath(ctx, d, side);
    ctx.closePath();
    ctx.fill();
    ctx.restore();
  }

  function strokeGoalCircle(ctx, d, color, side) {
    ctx.save();
    ctx.strokeStyle = color;
    ctx.lineWidth = Math.max(1, d.line * d.scaleAvg);
    ctx.lineCap = 'butt';
    ctx.lineJoin = 'round';
    ctx.beginPath();
    goalCirclePath(ctx, d, side);
    ctx.stroke();
    ctx.restore();
  }

  function fillPost(ctx, d, color, side) {
    const y = d.W * 0.5;
    const r = clamp(d.postR, d.line, Math.max(d.line, d.radius * 0.08));
    const x = side === 'right' ? d.L - r : r;
    ctx.save();
    ctx.fillStyle = color;
    ctx.beginPath();
    ctx.ellipse(mx(d, x), my(d, y), r * d.scaleAvg, r * d.scaleAvg, 0, 0, Math.PI * 2);
    ctx.fill();
    ctx.restore();
  }

  const PARTS = [
    makePart('netballLeftThird', 10, 'area', 'main', 'left', (ctx, d, color) => fillRect(ctx, d, color, 0, 0, d.L / 3, d.W)),
    makePart('netballCenterThird', 20, 'area', 'main', 'center', (ctx, d, color) => fillRect(ctx, d, color, d.L / 3, 0, d.L / 3, d.W)),
    makePart('netballRightThird', 30, 'area', 'main', 'right', (ctx, d, color) => fillRect(ctx, d, color, (d.L * 2) / 3, 0, d.L / 3, d.W)),
    makePart('netballLeftGoalCircleArea', 40, 'key', 'key', 'left', (ctx, d, color) => fillGoalCircle(ctx, d, color, 'left')),
    makePart('netballRightGoalCircleArea', 50, 'key', 'key', 'right', (ctx, d, color) => fillGoalCircle(ctx, d, color, 'right')),
    makePart('netballSidelineTop', 200, 'line', 'lines', 'center', (ctx, d, color) => fillPerimeterStrip(ctx, d, color, 'top')),
    makePart('netballSidelineBottom', 210, 'line', 'lines', 'center', (ctx, d, color) => fillPerimeterStrip(ctx, d, color, 'bottom')),
    makePart('netballGoalLineLeft', 220, 'line', 'lines', 'center', (ctx, d, color) => fillPerimeterStrip(ctx, d, color, 'left')),
    makePart('netballGoalLineRight', 230, 'line', 'lines', 'center', (ctx, d, color) => fillPerimeterStrip(ctx, d, color, 'right')),
    makePart('netballTransverseLineLeft', 240, 'line', 'lines', 'center', (ctx, d, color) => strokeLine(ctx, d, color, d.L / 3, 0, d.L / 3, d.W, d.line)),
    makePart('netballTransverseLineRight', 250, 'line', 'lines', 'center', (ctx, d, color) => strokeLine(ctx, d, color, (d.L * 2) / 3, 0, (d.L * 2) / 3, d.W, d.line)),
    makePart('netballCenterCircle', 260, 'line', 'lines', 'center', (ctx, d, color) => strokeCircle(ctx, d, color, d.L * 0.5, d.W * 0.5, d.centerR, d.line)),
    makePart('netballLeftGoalCircleLine', 270, 'line', 'lines', 'left', (ctx, d, color) => strokeGoalCircle(ctx, d, color, 'left')),
    makePart('netballRightGoalCircleLine', 280, 'line', 'lines', 'right', (ctx, d, color) => strokeGoalCircle(ctx, d, color, 'right')),
    makePart('netballGoalPostLeft', 290, 'line', 'lines', 'left', (ctx, d, color) => fillPost(ctx, d, color, 'left')),
    makePart('netballGoalPostRight', 300, 'line', 'lines', 'right', (ctx, d, color) => fillPost(ctx, d, color, 'right'))
  ];

  const PART_LOOKUP = PARTS.reduce((acc, part) => {
    acc[part.id] = part;
    return acc;
  }, Object.create(null));
  const DRAW_ORDER = PARTS.slice().sort((a, b) => a.order - b.order).map(part => part.id);
  const LINE_ONLY_ORDER = DRAW_ORDER.filter(id => PART_LOOKUP[id] && PART_LOOKUP[id].role === 'line');

  function pickDetailColor(detailColors, fallbackColors, id, fallback, baseColor) {
    if (detailColors && detailColors[id]) {
      if (detailColors[id] === SKIP_COLOR) return null;
      return detailColors[id];
    }
    if (fallbackColors && fallbackColors[id]) {
      if (fallbackColors[id] === SKIP_COLOR) return null;
      return fallbackColors[id];
    }
    if (fallback === 'key') return baseColor.key || baseColor.main;
    if (fallback === 'border') return baseColor.border || baseColor.main;
    if (fallback === 'lines') return baseColor.lines;
    return baseColor.main;
  }

  const DEFAULT_PALETTE = {
    main: '#2A7D68',
    key: '#1E9275',
    border: '#155E4D',
    lines: '#FFFFFF'
  };

  function draw(ctx, x0, y0, cw, ch, color, opts) {
    if (!ctx || !cw || !ch) return;
    const detailColors = (opts && opts.detailColors) || null;
    const fallbackColors = (opts && opts.fallbackColors) || null;
    const only = (opts && (opts.only === 'left' || opts.only === 'right')) ? opts.only : null;
    const useDetailedParts = !!(opts && opts.useDetailedParts);
    const hasCustom = hasKeys(detailColors) || hasKeys(fallbackColors);
    const drawDetailed = useDetailedParts || hasCustom;
    const order = drawDetailed ? DRAW_ORDER : LINE_ONLY_ORDER;

    ctx.save();
    ctx.translate(x0, y0);
    ctx.beginPath();
    ctx.rect(0, 0, cw, ch);
    ctx.clip();
    const dims = computeDims(cw, ch, opts || {});
    dims.hardwood = opts && opts.hardwood;
    const palette = {
      main: DEFAULT_PALETTE.main,
      key: DEFAULT_PALETTE.key,
      border: DEFAULT_PALETTE.border,
      lines: normHex(color || DEFAULT_PALETTE.lines)
    };

    for (const id of order) {
      const part = PART_LOOKUP[id];
      if (!part) continue;
      if (only && part.side && part.side !== only && part.side !== 'center') continue;
      const fill = pickDetailColor(detailColors, fallbackColors, id, part.fallback, palette);
      if (!fill) continue;
      try {
        part.draw(ctx, dims, normHex(fill));
      } catch (err) {
        try { console.warn('[SwishNetballLines] draw error for part', id, err); } catch (_) {}
      }
    }

    ctx.restore();
  }

  const api = {
    design: { W: DEFAULTS.WIDTH * 1000, L: DEFAULTS.LENGTH * 1000 },
    draw,
    ready: Promise.resolve()
  };

  return api;
}));
